import { Link } from "react-router-dom";
import { BRAND } from "@/lib/brand";

const INK = "#141311";
const BRONZE = "#A89880";
const MUTED = "#5C554A";

export function LegalShell({ title, updated, children }) {
  return (
    <div className="min-h-screen lp-body" style={{ background: "#FFFFFF", color: INK }}>
      <header className="px-6 md:px-12 py-5 border-b" style={{ borderColor: "rgba(20,19,17,0.07)" }}>
        <Link to="/" className="flex items-baseline gap-2" data-testid="legal-logo">
          <span className="font-script" style={{ fontSize: "2rem", color: INK }}>{BRAND.name}</span>
          <span className="lp-label-sm" style={{ color: BRONZE }}>{BRAND.tag}</span>
        </Link>
      </header>
      <main className="max-w-[760px] mx-auto px-6 md:px-12 py-16 md:py-24">
        <p className="lp-label-sm" style={{ color: BRONZE }}>Legal</p>
        <h1 className="lp-h mt-4 text-4xl md:text-5xl normal-case" style={{ textTransform: "none" }}>{title}</h1>
        <p className="lp-label-sm mt-4" style={{ color: MUTED }}>Last updated: {updated}</p>
        <div className="mt-10 space-y-8 text-[15px] leading-relaxed" style={{ color: MUTED }}>
          {children}
        </div>
        <div className="mt-16 pt-8 border-t flex flex-wrap gap-6" style={{ borderColor: "rgba(20,19,17,0.1)" }}>
          <Link to="/" className="lp-label-sm hover:opacity-60" style={{ color: INK }}>← Back home</Link>
          <Link to="/privacy" className="lp-label-sm hover:opacity-60" style={{ color: MUTED }}>Privacy Policy</Link>
          <Link to="/terms" className="lp-label-sm hover:opacity-60" style={{ color: MUTED }}>Terms of Service</Link>
        </div>
      </main>
    </div>
  );
}

export const H = ({ children }) => (
  <h2 className="lp-h text-2xl normal-case" style={{ textTransform: "none", color: INK }}>{children}</h2>
);
